import * as React from 'react';

function SvgLandlordRelatedInformationGray(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} {...props}>
      <g fill="none">
        <path
          fill="#F8F8F6"
          d="M20.885 4.7c5.083 0 9.2 4.116 9.2 9.2 0 3.3-1.751 6.191-4.373 7.807 1.247.382 2.429.914 3.525 1.573l.688-.648c.544-.51 1.368-.51 1.885.005l7.244 7.003c.268.268.409.61.409.987v7.002c0 .754-.615 1.37-1.369 1.37h-1.218V39H5.124A16.158 16.158 0 015 37c0-5.464 2.739-10.288 6.918-13.174a14.358 14.358 0 014.059-2.17l-.252-.165a9.161 9.161 0 01-4.039-7.592c0-5.065 4.125-9.199 9.2-9.199z"
        />
        <path
          fill="#C8C9CB"
          d="M24.814 18.47l7.244 7.003c.268.268.408.61.408.987v7.002c0 .753-.615 1.369-1.369 1.369H16.372a1.372 1.372 0 01-1.369-1.37v-6.947c0-.38.17-.756.442-.994l7.483-7.055c.544-.51 1.369-.51 1.886.004zM16.185 1c5.083 0 9.2 4.116 9.2 9.2 0 4.98-3.986 9.027-8.934 9.168l-.333.003-.314-.008c-7.347.185-12.6 6.141-12.6 14.34 0 .62-.482 1.101-1.102 1.101-.62 0-1.102-.482-1.102-1.102 0-4.597 1.528-8.81 4.302-11.828a14.46 14.46 0 015.975-3.918l-.252-.165A9.161 9.161 0 016.986 10.2c0-5.065 4.125-9.199 9.2-9.199zm7.667 19.595l-6.645 6.262v5.77h5.546v-3.871c0-.62.482-1.102 1.102-1.102.579 0 1.037.42 1.096.98l.006.122v3.871h5.306v-5.826l-6.41-6.206zM16.185 3.203c-3.852 0-6.995 3.136-6.995 6.996a6.959 6.959 0 006.392 6.945l.24.016.337-.006.086.003.085.01.237-.01a6.988 6.988 0 006.614-6.985c0-3.854-3.138-6.969-6.996-6.969z"
        />
      </g>
    </svg>
  );
}

export default SvgLandlordRelatedInformationGray;
